import React from 'react';
import configureStore from './configureStore';
import {Provider} from "react-redux";
import AppContainer from "./AppContainer";
import {ConnectedRouter} from "connected-react-router";
import history from "./history";
const store = configureStore(history);

const reduxContainer= () => {

    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                    <AppContainer/>
            </ConnectedRouter>
        </Provider>
    );

}
export default reduxContainer;